import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';

import RightPanel from '../../components/requests-list-item/right-panel';
import { setCollapseKey } from '../../redux/actions/requests';


const mapStateToProps = state => ({
  collapseKey: state.requests.collapseKey,
  isRemoving: state.tasks.isRemoving ||
              state.comments.isRemoving ||
              state.meetingNotes.isRemoving ||
              state.logs.isRemoving,
});

export default compose(
  connect(mapStateToProps, { setCollapseKey }),
  withHandlers({
    onCollapseKeyChange: props => (key) => {
      if (!props.isRemoving) props.setCollapseKey({ collapseKey: key || -1 });
    },
  }),
)(RightPanel);



// WEBPACK FOOTER //
// ./src/containers/requests-list-item/right-panel.js